import { useIncidentDescription } from '../../../../features/incident-drawer/feed/hooks/useIncidentDescription'

import { Box, Flex } from '@chakra-ui/react'

import { IncidentCreatorType } from '@/features/incident-drawer'
import { IncidentType } from '@/graphql/generated/schemas'
import { DeviceType } from '@/graphql/generated/schemas'

import { ButtonTag } from '../../ButtonTag'
import { DeviceIcon } from './DeviceIcon'
import { FloorIcon } from './FloorIcon'
import { ManualIncidentDescription } from './ManualIncidentDescription'

interface IncidentDescriptionIProps {
  type: IncidentType
  description?: string
  floorName?: string
  floorId?: string
  deviceName?: string
  deviceType?: DeviceType
  deviceId?: string
  showButtonTag?: boolean
  creator?: IncidentCreatorType
}

export const IncidentDescription = ({
  type,
  creator,
  description,
  floorName,
  floorId,
  deviceName,
  deviceType,
  deviceId,
  showButtonTag = true,
}: IncidentDescriptionIProps) => {
  const { message, onDeviceClick, onFloorClick } = useIncidentDescription({
    deviceId,
    deviceType,
    floorId,
    type,
  })

  switch (type) {
    case IncidentType.DoorHeldOpen:
    case IncidentType.DoorHeldClose:
    case IncidentType.ForcedEntry:
    case IncidentType.LineCrossing:
    case IncidentType.Alarm:
      return (
        <Box
          as='span'
          mt='5px'
          style={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            alignItems: 'center',
            wordBreak: 'break-word',
            whiteSpace: 'normal',
            rowGap: '2px',
          }}
        >
          {/* region Door */}
          {showButtonTag ? (
            <>
              <Box
                alignItems='center'
                as='span'
                display='inline-flex'
                margin='2px'
                verticalAlign='middle'
              >
                <ButtonTag onClick={onDeviceClick}>
                  <DeviceIcon type={deviceType} />
                  {deviceName}
                </ButtonTag>
              </Box>
              <Box
                as='span'
                display='inline'
                marginX='1'
                verticalAlign='middle'
              >
                on
              </Box>
            </>
          ) : (
            <Box
              alignItems='center'
              as='span'
              display='inline-flex'
              maxW='40%'
              verticalAlign='middle'
            >
              <DeviceIcon type={deviceType} />
              <Box as='span' mr='1' verticalAlign='middle'>
                {`${deviceName} on `}
              </Box>
            </Box>
          )}
          {/* endregion */}

          {/* region Floor */}
          {showButtonTag ? (
            <Box
              alignItems='center'
              as='span'
              display='inline-flex'
              margin='2px'
              verticalAlign='middle'
            >
              <ButtonTag onClick={onFloorClick}>
                <FloorIcon />
                {floorName}
              </ButtonTag>
            </Box>
          ) : (
            <Box
              alignItems='center'
              as='span'
              display='inline-flex'
              maxW='30%'
              verticalAlign='middle'
            >
              <FloorIcon />
              <Box as='span' verticalAlign='middle'>
                {floorName}
              </Box>
            </Box>
          )}
          {/* endregion */}

          {/* region Message */}
          <Box as='span' display='inline' margin='2px' verticalAlign='middle'>
            {message}
          </Box>
          {/* endregion */}
        </Box>
      )
    case IncidentType.Tailgating:
      return (
        <Flex direction='column'>
          <span>{message}</span>
        </Flex>
      )
    default:
      return (
        <ManualIncidentDescription
          creator={creator}
          description={description}
        />
      )
  }
}
